export const DEFAULT_BULK_UPLOAD_ERROR_MESSAGE = 'Unable to submit bulk upload. Please try again.';

const resolveGraphqlErrorMessage = (errors) => {
  if (!Array.isArray(errors)) {
    return null;
  }

  for (const entry of errors) {
    if (typeof entry === 'string' && entry.trim()) {
      return entry.trim();
    }
    if (entry && typeof entry === 'object' && typeof entry.message === 'string' && entry.message.trim()) {
      return entry.message.trim();
    }
  }

  return null;
};

export const resolveBulkUploadErrorMessage = (
  error,
  {
    defaultMessage = DEFAULT_BULK_UPLOAD_ERROR_MESSAGE,
    includeCauseMessage = false,
  } = {},
) => {
  if (!error) {
    return defaultMessage;
  }

  if (typeof error === 'string' && error.trim()) {
    return error.trim();
  }

  if (error instanceof Error && typeof error.message === 'string' && error.message.trim()) {
    return error.message.trim();
  }

  const messageCandidates = [
    resolveGraphqlErrorMessage(error?.errors),
    resolveGraphqlErrorMessage(error?.response?.errors),
    resolveGraphqlErrorMessage(error?.data?.errors),
    typeof error?.errorMessage === 'string' ? error.errorMessage.trim() : '',
    includeCauseMessage && typeof error?.cause?.message === 'string' ? error.cause.message.trim() : '',
  ].filter(Boolean);

  if (messageCandidates.length > 0) {
    return messageCandidates[0];
  }

  return defaultMessage;
};
